import React, { Component } from 'react';
import NowellonEditableFieldPropType from "../NowellonEditableField/NowellonEditableFieldPropType";
import PlayerYoutube from "../Shared/PlayerYoutube";
// import NowellonEditableField from "../NowellonEditableField";
import PropTypes from 'prop-types';
import shortid from "shortid";

class VideoSectionComponent extends Component {
  constructor(props) {
    super(props);
  }
  getSocialMediaShareUrl = (type, url = "") => {
    if (type === "Facebook") {
      return `https://www.facebook.com/sharer.php?u=${url}`;
    } else if (type === "Twitter") {
      return `http://twitter.com/intent/tweet?url=${url}`;
    }
  }
  render() {
    const {
      getVal,
      VideoSection,
      WatchVideoText,
      expertIndex
    } = this.props;
    return (
      <div className="expert-tab-content expert-videos">
        <ul className="expert-videos-list">
          {VideoSection.map((v) => (
            <li key={shortid.generate()} className="expert-videos-item">
              {/*<ul className="socialbox">
                <li><a target="_blank" href={this.getSocialMediaShareUrl("Facebook", getVal(v.VideoUrl))} className="ico-facebook ir" title="facebook">facebook</a></li>
                <li><a target="_blank" href={this.getSocialMediaShareUrl("Twitter", getVal(v.VideoUrl))} className="ico-twitter ir" title="twitter">twitter</a></li>
                <li><a target="_blank" href="#" className="ico-instagram ir" title="instagram">instagram</a></li>
              </ul>*/}
                <PlayerYoutube
                    teaserId={shortid.generate()}
                    youtubeUrl={v.VideoUrl.Value}
                    teaser={{
                        YoutubeImage: v.VideoCoverUrl,
                        YoutubeImageAlt: v.VideoCoverAlt,
                        ShadowColour: v.ShadowColour,
                        YoutubeUrl: v.VideoUrl,
                        WatchVideoText: WatchVideoText
                    }}
                />
              <div className="expert-videos-text">
                <p dangerouslySetInnerHTML={{ "__html": getVal(v.Question) }} />
                <p dangerouslySetInnerHTML={{ "__html": getVal(v.Anwser) }} />
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
VideoSectionComponent.propTypes = {
  getVal: PropTypes.func.isRequired,
  VideoSection: PropTypes.arrayOf(
    PropTypes.shape({
      VideoUrl: NowellonEditableFieldPropType.isRequired,
      VideoCoverUrl: NowellonEditableFieldPropType.isRequired,
      ImageAlt: NowellonEditableFieldPropType.isRequired,
      ShadowColour: NowellonEditableFieldPropType.isRequired,
      PlayVideoText: NowellonEditableFieldPropType.isRequired,
      Question: NowellonEditableFieldPropType.isRequired,
      Anwser: NowellonEditableFieldPropType.isRequired
    })
  ).isRequired,
  WatchVideoText: NowellonEditableFieldPropType.isRequired,
  expertIndex: PropTypes.string.isRequired
}
export default VideoSectionComponent;
